import { useEffect, useState } from 'react'

export const useIsCreate = (routeParam: string, createSymbol = 'create') => {
	const [isCreate, setIsCreate] = useState(routeParam === createSymbol)

	useEffect(() => {
		setIsCreate(routeParam === createSymbol)
	}, [routeParam, createSymbol])

	return isCreate
}
